<script>
  import Header from "./Header.svelte";
  import BioCard from "./BioCard.svelte";
  let bios = [
      {
          name: "Mona Eltahawy",
          description: "Author of 'The 7 Necessary Sins for Women and Girls'",
          image: "eltahawy.jpg",
          twitter: "monaeltahawy"
      },
      {
          name: "Tiffany Mugo",
          description: "Co-editor of 'Touch: Sex, Sexuality and Sensuality'",
          image: "mugo.jpg",
          twitter: "tiffmugo"
      },
      {
          name: "Nana Darkoa Sekyiamah",
          description: "Author of 'The Sex Lives of African Women'",
          image: "sekyiamah.jpg",
          twitter: "nas009"
      },
      {
        name: "Eliza Anyangwe",
        description: "CNN As Equals Editor (moderator)",
        image: "anyangwe.jpg",
        twitter: "ElizaTalks"
      }
      
  ]
  let destination = "https://warnermedia.zoom.us/webinar/register/WN_7StNe3R1QY-5ZslJl5UU_Q";
  let destination2 = 'https://warnermedia.zoom.us/webinar/register/WN_P6q4m3FnSfKOU2HhheMWVA';
  let padding = 37;

  let clientWidth = 800;
  let numCols = 4;
  $: {
    if(clientWidth > 600) {
      numCols = 2;
    } else {
      numCols = 1;
    }

  }


</script>

<div class="main" bind:clientWidth>
    <Header text="As Equals" logoSize={padding} />
    <div class="inner" style="--padding: {padding}px;">
        <h1>White lies launch event</h1>

        <p class="text">
            Join CNN's gender reporting team As Equals as we launch White lies, a new series committed to exposing the dangers of skin whitening.
        </p>
        <p class="text">
            We will be hosting a virtual conversation on the issue with journalists across CNN, alongside experts and advocates who are fighting to end skin whitening and the broader problem of colorism that fuels it.
        </p>

        <!-- <ul>
            {#each bios as { name, description, image, twitter }}
                <li style="width: calc(100% / {numCols});">
                    <BioCard
                        {name}
                        {description}
                        {image}
                        {twitter}
                        imageSize={60}
                    />
                </li>
            {/each}
        </ul> -->
        <div class="button-container">
            <div class="date">November 23, 2021</div>
            <div class="times">1pm ET, 6pm GMT, 7pm WAT/CET</div>
            <a class="button" href={destination} target="_blank"
                >Register here</a
            >
        </div>

        <div class="button-container">
            <div class="date">November 24, 2021</div>
            <div class="times">12:30pm GMT, 6pm IST, 8:30pm HKT</div>
            <a class="button" href={destination2} target="_blank"
                >Register here</a
            >
        </div>
    </div>
</div>

<style>
    .main {
        font-family: CNN;
        border: 1px solid #fff;
        background-color: #000;
        color: #fff;
        font-size: .9rem;        
    }
    
    .inner {
        padding: 1em var(--padding) var(--padding) var(--padding);
    }
    h1 {
        padding: 0;
        margin: 0;
        font-weight: 500;
        line-height: 1.1;
        /* text-transform: uppercase; */
        margin-bottom: 0.3em;
        font-size: 1.7em;
    }
    /* strong {
        font-weight: 500;
    } */
    .text {
        max-width: 600px;
        font-weight: 300;
        margin-bottom: 1.5em;
    }
    .button-container {
        margin-top: 1.25em;
        display: inline-block;
        margin-right: 5px;
    }
    .date,
    .times {
        font-size: 1em;
    }
    .button {
        font-weight: 800;
        text-transform: uppercase;
        border: 1px solid #fff;
        font-size: 0.7em;
        padding: 8px 20px;
        color: #fff;
        display: inline-block;
        margin-top: 8px;
    }
    ul {
        padding: 0;
        list-style: none;
        display: flex;
        margin: -1em;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
    }

    /* @media screen and (max-width: 680px) {
        ul {
            flex-direction: column;
        }
    } */

    li {
        padding: 1em;
        box-sizing: border-box;
    }

    @media screen and (min-width: 768px) {
        .main {
            font-size: 1rem;
        }      
        .button-container {
            margin-top: 2em;
            margin-right: 40px;
        }  
        h1 {
            font-size: 3em;
        }
    }

</style>
